import {
  Button,
  Card,
  CardBody,
  Flex,
  Heading,
  Image,
  ListItem,
  Stack,
  Text,
  UnorderedList,
  useBreakpointValue,
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

export default function HomeHero() {
  const navigate = useNavigate();
  
  return (
    <Stack mb="100px" px={{ base: "14px", sm: "15vw" }} minH={'20vh'} direction={{ base: 'column', lg: 'row' }} fontWeight="300" color="#1C3E64">
      <Flex p={8} flex={1} align={'center'} justify={'center'}>
        <Stack spacing={6} w={'full'} maxW={'lg'}>
          <Heading fontSize={{ base: '2xl', md: '3xl', lg: '4xl' }}>
            <Text
              fontSize="41px"
              fontWeight="300"
              pb="8px"
              borderBottom="1px solid rgba(28, 62, 100, 0.50)"
            >
              Submit Your Real Estate
            </Text>
            <br />{' '}

          </Heading>

          <Text fontSize="19px" color={'#002B5B'} as={'span'}>
            We accept Commercial Real Estate (CRE) from across Africa and we are always looking to help real estate developers/owners leverage Asset Tokenization CRE community to raise capital.
          </Text>{' '}



          <Text fontSize={{ base: 'md', lg: 'lg' }}>
            <Stack direction={{ base: 'column', md: 'row' }}>
              <Flex flex={1}>
                <UnorderedList>
                  <ListItem>Multifamily</ListItem>
                  <ListItem>Office</ListItem>
                  <ListItem>Industrial</ListItem>
                  <ListItem>Mixed Use</ListItem>
                </UnorderedList>
              </Flex>
              <Flex flex={1}>
                <UnorderedList>
                  <ListItem>Retail</ListItem>
                  <ListItem>Hospitality</ListItem>
                  <ListItem>Condominium</ListItem>
                  <ListItem>Student Housing</ListItem>
                </UnorderedList>
              </Flex>
            </Stack>
          </Text>
          <Stack direction={{ base: 'column', md: 'row' }} spacing={4}>
            <Button
              mt="24px"
              rounded={'full'}
              bg={'#002B5B'}
              color={'white'}
              _hover={{
                bg: 'transparent',
                color: "#1C3E64",
                border: "1px solid #002B5B"
              }}
              onClick={() => navigate('/contactus')}
            >
              Contact Us
            </Button>
          </Stack>
        </Stack>
      </Flex>
      <Flex flex={1}>
        <Card >
        <Flex
        alignItems="center"
        justifyContent="center"
        height="100%" // Set the height of the Flex container to 100% of the Card
      >
        <CardBody>
          <Image
            alt={'Login Image'}
            objectFit={'cover'}
            src={'https://images.unsplash.com/photo-1570129477492-45c003edd2be?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80'}
          />
        </CardBody>
      </Flex>

        </Card>
      </Flex>
    </Stack>
  );
}